import React from 'react';
import { useTranslation } from '../i18n/useTranslation';

function GnbLoginInducePanel({ onAction }) {
    const { t } = useTranslation();

    const openSignup = () => {
        onAction?.();
        if (window.openSignupPopup) window.openSignupPopup();
    };

    const openLogin = () => {
        onAction?.();
        if (window.openLoginPopup) window.openLoginPopup();
    };

    return (
        <div className="gnb-login-induce">
            <span className="gnb-login-induce-texture" aria-hidden="true" />
            <div className="gnb-login-induce-content">
                <h4 className="gnb-login-induce-headline">{t('login.induceHeadline')}</h4>
                <div className="gnb-login-induce-buttons gap16">
                    <button
                        type="button"
                        className="gnb-login-induce-btn btn-rtg btn-primary"
                        onClick={openSignup}
                        aria-label={t('login.induceJoin')}
                        title={t('login.induceJoin')}
                    >
                        <span className="material-symbols-rounded gnb-login-induce-btn-icon" aria-hidden="true">person_add</span>
                        <span className="gnb-login-induce-btn-label">{t('login.induceJoin')}</span>
                    </button>
                    <button
                        type="button"
                        className="gnb-login-induce-btn btn-rtg btn-line"
                        onClick={openLogin}
                        aria-label={t('login.induceHaveAccount')}
                        title={t('login.induceHaveAccount')}
                    >
                        <span className="material-symbols-rounded gnb-login-induce-btn-icon" aria-hidden="true">login</span>
                        <span className="gnb-login-induce-btn-label">{t('login.induceHaveAccount')}</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default GnbLoginInducePanel;
